// removed by extract-text-webpack-plugin
module.exports = {"Spinner":"Spinner__Spinner___1pQ49","Blur":"Spinner__Blur___2f7ZN","doubleBounce":"Spinner__doubleBounce___3vxky","doubleBounce1":"Spinner__doubleBounce1___2vtrj","doubleBounce2":"Spinner__doubleBounce2___1c2rU","bounce":"Spinner__bounce___33Jal"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Spinner/Spinner.scss
// module id = 1486
// module chunks = 0